import React, { useMemo } from "react";
import { useTable, useGlobalFilter, useFilters, usePagination } from "react-table";
import { Col, Table, Row } from "reactstrap";
import { GlobalFilter } from "./GlobalFilter";

function ReactTableComponent({ columns, data }) {
  const defaultColumn = useMemo(() => {
    return {
      Filter: GlobalFilter,
    };
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    state,
    gotoPage,
    pageCount,
    prepareRow,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      defaultColumn
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;
  return (
    <>
      <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
      <div>
        <Table striped bordered hover responsive {...getTableProps}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td  className="mytb"{...cell.getCellProps()}>{cell.render("Cell") } </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <Row className="mt-3">
      <Col md={6}>
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <span>
          | Go To Page:{" "}
          <input className="form-control d-inline-block rounded"
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const pageNumber = e.target.value
                ? Number(e.target.value) - 1
                : 0;
              gotoPage(pageNumber);
            }}
            style={{ width: "50px" }}
          />
        </span>
        <label className="mx-2">Show: </label>
        <select className="form-control d-inline-block w-auto rounded"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 25, 50].map((ps) => (
            <option key={ps} value={ps}>
              {ps}
            </option>
          ))}
        </select>
        </Col>
        <Col md={6}>
          <ul class="pagination justify-content-end">
            <li>
            <button onClick={() => gotoPage("0")} disabled={!canPreviousPage}>
              {"<<"}
            </button>
            </li>
            <li>
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              Previos
            </button>
            </li>
            <li>
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              Next
            </button>
            </li>
            <li>
            <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
              {">>"}
            </button>
            </li>
          </ul>
        </Col>
      </Row>
    </>
  );
}

export default ReactTableComponent;
